export enum ECommentType {
  NORMAL = 'normal',
  ANSWER_REQUEST = 'answer_request',
}
